import BaseWidget from './baseWidget.js';
import dashboardService from '../../services/dashboardService.js';

const COLORS = [
	{ value: 'transparent', swatch: 'var(--main-background)', label: 'Standard' },
	{ value: 'var(--custom-orange)', label: 'Orange' },
	{ value: 'var(--custom-light-blue)', label: 'Blau' },
	{ value: 'var(--custom-light-pink)', label: 'Rosa' },
	{ value: 'var(--custom-turquoise)', label: 'Grün' },
];

/**
 * Persönlicher Notizzettel, ausschließlich im localStorage gespeichert.
 * Jede Widget-Instanz hat einen eigenen Speicherbereich (key per instanceId),
 * sodass mehrere Notizzettel parallel genutzt werden können.
 */
export default class NotepadWidget extends BaseWidget {
	constructor(type, instanceId, state = {}) {
		super(type, instanceId, state);
		this.color = state.color || COLORS[0].value;
	}

	serializeState() {
		return { color: this.color };
	}

	loadText() {
		return dashboardService.getNote(this.instanceId);
	}

	saveText(text) {
		dashboardService.setNote(this.instanceId, text);
	}

	async onRemove() {
		await dashboardService.deleteNote(this.instanceId);
	}

	getRemovalWarning() {
		const text = (dashboardService.getNote(this.instanceId) || '').trim();
		if (!text) return null; // leere Notiz → keine Warnung nötig
		return 'Möchten Sie diesen Notizzettel wirklich entfernen?\nDer enthaltene Text geht dabei verloren.';
	}

	async onRender() {
		const text = this.loadText();
		this.bodyEl.innerHTML = `
			<div class="widget-notepad-wrap">
				<textarea class="widget-notepad" placeholder="Notiz schreiben..."></textarea>
				<div class="widget-notepad-colors">
					${COLORS.map((c) => `
						<button type="button" class="notepad-color${this.color === c.value ? ' active' : ''}"
							style="background:${c.swatch || c.value};"
							data-color="${c.value}"
							title="${c.label}"></button>
					`).join('')}
				</div>
			</div>
		`;
		this.applyColor();
		const textarea = this.bodyEl.querySelector('.widget-notepad');
		textarea.value = text;
		let saveTimer;
		textarea.addEventListener('input', () => {
			clearTimeout(saveTimer);
			saveTimer = setTimeout(() => this.saveText(textarea.value), 300);
		});
		this.bodyEl.querySelectorAll('.notepad-color').forEach((btn) => {
			btn.addEventListener('click', () => {
				this.color = btn.dataset.color;
				this.applyColor();
				this.bodyEl.querySelectorAll('.notepad-color').forEach((b) => {
					b.classList.toggle('active', b.dataset.color === this.color);
				});
				if (window.myServices?.dashboard) {
					window.myServices.dashboard.saveConfig();
				}
			});
		});
	}

	applyColor() {
		this.bodyEl.style.background = this.color;
	}
}
